import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    csvSelected: {
      backgroundColor: 'unset',
    },
    subheader: {
      padding: theme.spacing(1),
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
    },
    label: {
      marginBottom: theme.spacing(1),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
    icon: {
      '& rect': {
        fill: 'transparent',
      },
    },
  }),

  { name: 'SourceSelect' }
);
